module.exports = __webpack_public_path__ + "img/vedioimg.f8819647.png";